import { render, staticRenderFns } from "./ExternalLogin.vue?vue&type=template&id=60f22aee"
import script from "./ExternalLogin.vue?vue&type=script&lang=js"
export * from "./ExternalLogin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports